
import { live, test, json, news, reg, chat, join, expert, expertreg, login, index, talk,qzyz, inovice } from './path'
import { requestControl } from './requestControl'

// 静态牧场选择题
export function pasture(data) { return requestControl(json.pasture, data) }
// 静态牧场选择题
export function laboratory(data) { return requestControl(json.laboratory, data) }

// 获取短信验证码
export function getclassList(data) { return requestControl(login.getclassList, data) }
// 获取短信验证码
export function getUserSendCode(data) { return requestControl(login.getUserSendCode, data) }
// 中科名兽医手机登录
export function zkmsyPhonelogin(data) { return requestControl(login.zkmsyPhonelogin, data) }
// 获取用户信息
export function getUserInfo(data) { return requestControl(login.getUserInfo, data) }

// 获取直播视频详情
export function getLiveDetail(data) { return requestControl(live.getLiveDetail, data) }
// 统计分享次数
export function getLiveShareInc(data) { return requestControl(live.getLiveShareInc, data) }
// 获取分享列表
export function getLiveShareList(data) { return requestControl(live.getLiveShareList, data) }
// 查询直播状态
export function getLiveStatus(data) { return requestControl(live.getLiveStatus, data) }
// 获取直播视频
export function sharevideolive(data) { return requestControl(live.sharevideolive, data) }
// 直播断流获取数据
export function getendtime(data) { return requestControl(live.getendtime, data) }
// 获取点播视频
export function sharevideoinfo(data) { return requestControl(live.sharevideoinfo, data) }

// 浏览记录
export function getaccessstatus(data) { return requestControl(test.getaccessstatus, data) }
// 疫病检测某一套检测题目
export function diseaseexam(data) { return requestControl(test.diseaseexam, data) }
// 疫病检测列表/某一套检测题
export function diseaseexam1(data) { return requestControl(test.diseaseexam1, data) }
// 提交疫病检测列表检测题
export function answerdisease(data) { return requestControl(test.answerdisease, data) }
// 牧场选择题结果
export function farmanswer(data) { return requestControl(test.farmanswer, data) }
// 实验室选择题结果
export function labbiosafetyeval(data) { return requestControl(test.labbiosafetyeval, data) }
// 伪狂犬病净化结果
export function getresults(data) { return requestControl(test.getresults, data) }

// 兽医头条
export function newsdetail(data) { return requestControl(news.newsdetail, data) }
export function pigLog(data) { return requestControl(news.pigLog, data) }
export function allPrice(data) { return requestControl(news.allPrice, data) }
export function getProvince(data) { return requestControl(news.getProvince, data) }
// 排行
export function rankList(data) { return requestControl(news.rankList, data) }
export function priceshow(data) { return requestControl(news.priceshow, data) }
export function getdict(data) { return requestControl(news.getdict, data) }
export function priceline(data) { return requestControl(news.priceline, data) }
export function getCity(data) { return requestControl(news.getCity, data) }

// 中科基因验证码
export function websmscode(data) { return requestControl(reg.websmscode, data) }
// 中科基因获取IP
export function userregisterclick(data) { return requestControl(reg.userregisterclick, data) }
// 中科基因注册1
export function smslogin(data) { return requestControl(reg.smslogin, data) }
// 中科基因注册2
export function websetdevotecode(data) { return requestControl(reg.websetdevotecode, data) }

// 中科名兽医微信分享
export function wxshare(data) { return requestControl(live.wxshare, data) }

// 加入我们信息
export function joinus(data) { return requestControl(join.joinus, data) }
// 加入我们信息
export function ourpartners(data) { return requestControl(join.ourpartners, data) }

// 聊天历史
export function chathistory(data) { return requestControl(chat.chathistory, data) }

// 专家详情
export function expertinfo(data) { return requestControl(expert.expertinfo, data) }
// 专家详情
export function getExpertDetail(data) { return requestControl(expert.getExpertDetail, data) }

// 报名表详情
export function activityGetSignInfo(data) { return requestControl(expert.activityGetSignInfo, data) }

// 保存签名
export function activityEditSignInfo(data) { return requestControl(expert.activityEditSignInfo, data) }

// 代付列表
export function activityPayList(data) { return requestControl(expert.activityPayList, data) }

// 确认代付
export function activityPayConfirm(data) { return requestControl(expert.activityPayConfirm, data) }

// 免费课程视频统计
export function getVideoIncr(data) { return requestControl(expert.getVideoIncr, data) }
// 课程概述
export function getCourseDetail(data) { return requestControl(expert.getCourseDetail, data) }
// 获取课程目录信息
export function getCourseCatalog(data) { return requestControl(expert.getCourseCatalog, data) }
// 免费试听
export function getCourseFree(data) { return requestControl(expert.getCourseFree, data) }

// 专家基础信息接口
export function getUserType(data) { return requestControl(expertreg.getUserType, data) }
// 专家获取验证码接口
export function getSendCode(data) { return requestControl(expertreg.getSendCode, data) }
export function getSmsCode(data) { return requestControl(expertreg.getSmsCode, data) }
// 专家登录接口
export function getZkmsyPhonelogin(data) { return requestControl(expertreg.getZkmsyPhonelogin, data) }
// phython登录接口
export function tokenlogin(data) { return requestControl(expertreg.tokenlogin, data) }
// phython专家注册接口
export function updateexpertinfo(data) { return requestControl(expertreg.updateexpertinfo, data) }
// 专家注册类型
export function identity(data) { return requestControl(expertreg.identity, data) }
// 专家注册类型
export function userSweepqrcode(data) { return requestControl(expertreg.userSweepqrcode, data) }

// 首页信息
export function leavingMessageAdd(data) { return requestControl(index.leavingMessageAdd, data) }

// 话题详情
export function getTopicDetail(data) { return requestControl(talk.getTopicDetail, data) }

// 商品详情
export function goodDetail(data) { return requestControl(talk.goodDetail, data) }

// 商品优惠券
export function goodEnable(data) { return requestControl(talk.goodEnable, data) }

// // 组方详情
export function compreDetail(data) { return requestControl(talk.compreDetail, data) }

// 专家详情
export function tmgetExpertDetail(data) { return requestControl(talk.tmgetExpertDetail, data) }

// 禽智养殖
export function pointList(data) { return requestControl(qzyz.pointList, data) }

export function shedList(data) { return requestControl(qzyz.shedList, data) }
// 巡查详情
export function tourinfo(data) { return requestControl(qzyz.tourinfo, data) }
// 工作详情
export function workinfo(data) { return requestControl(qzyz.workinfo, data) }
// 天气
export function farmWeather(data) { return requestControl(qzyz.farmWeather, data) }


/* ------------------------------------发票------------------------------------------- */
export function inoviceInfo(data) { return requestControl(inovice.inoviceInfo, data) }
export function getInvoiceTitles(data) { return requestControl(inovice.getInvoiceTitles, data) }
export function saveInvoice(data) { return requestControl(inovice.saveInvoice, data) }
/* ------------------------------------发票------------------------------------------- */
